import { Component, OnInit, Input, HostBinding, ViewChild, ElementRef, HostListener } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { config } from '../../app.config';
import get from 'lodash.get';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { MqService } from '../../service/mq.service';
import { IVideoPickerVideoData } from 'src/app/shared/interface/video-picker-data';

interface VideoCarouselPanelData {
  title?: IUProperty<string>;
  description?: IUProperty<string>;
  items: any;
}

enum VideoState {
  active = 'active',
  inactive = 'inactive'
}

enum DropdownState {
  opened = 'opened',
  closed = 'closed'
}

export interface IVideoViewModel {
  video: object;
}

@Component({
  selector: 'app-video-carousel-panel',
  templateUrl: './video-carousel-panel.component.html',
  styleUrls: ['./video-carousel-panel.component.less'],
  animations: [
    trigger('dropdown', [
      state('opened', style({
        height: '*',
        opacity: '1',
      })),
      state('closed', style({
        opacity: '0',
        height: '0',
        display: 'none',
      })),
      transition('* => *', [animate('.3s ease-in-out')])
    ]),
    trigger('arrow', [
      state('active', style({
        opacity: '1',
        fill: '#6F8D6f',
        stroke: '#6F8D6F'
      })),
      state('inactive', style({
        opacity: '0',
        fill: 'transparent',
        stroke: 'transparent'
      })),
      transition('* => *', [animate('.1s ease-in-out')])
    ])
  ]
})
export class VideoCarouselPanelComponent implements OnInit {
  @Input() data: VideoCarouselPanelData;
  @ViewChild('panelEl', { static: false }) panelEl: ElementRef<HTMLElement>;

  @HostListener('window:scroll', []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelEl.nativeElement.offsetTop) {
      this.loadMedia = true;
    }
  }

  videoData: IVideoViewModel;
  items: any[] = [];
  isMobile: boolean;
  readonly desktopMediaQuery = config.desktopMediaQuery || '(min-width: 768px)';

  currentItem: number;
  dropdownOpened: string = DropdownState.closed;
  videoStates = VideoState;
  dropdownStates = DropdownState;
  isClicked: boolean;
  scrollPosition: number = null;
  loadMedia: boolean = false;

  constructor(
    private _sanitizer: DomSanitizer,
    private mq: MqService
  ) { }

  ngOnInit() {
    this.mq.mobileDesktop(this.changeToMobile.bind(this), this.changeToDesktop.bind(this));
    this.items = this.data.items.value.map(item => {
      item.state = VideoState.inactive;
      item.dropdown = DropdownState.closed;
      return ({
        ...item,
        videoData: this.isMobile ? this.mobile(item) : this.desktop(item)
      });
    }
    );

    this.items[0].state = VideoState.active;
    this.items[0].dropdown = DropdownState.opened;
    this.currentItem = 0;
    this.isClicked = false;
  }

  ngAfterViewInit(): void {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelEl.nativeElement.offsetTop) {
      this.loadMedia = true;
    }
  }

  changeToMobile() {
    this.isMobile = true;
  }

  changeToDesktop() {
    this.isMobile = false;
  }

  mobile(item) {
    return this.prepareVm(get(item, 'video.value.mobile'));
  }
  desktop(item) {
    return this.prepareVm(get(item, 'video.value.desktop'));
  }

  open() {
    this.items[this.currentItem].isShow = true;
  }
  close() {
    this.items[this.currentItem].isShow = false;
  }

  private prepareVm(data: IVideoPickerVideoData): IVideoViewModel {
    if (!data) return null;

    return {
      video: {
        url: data.url,
        type: data.type,
      }
    };
  }

  toggleVideoState(item: any, index: number) {
    item.state = VideoState.active;
    this.items[this.currentItem].state = VideoState.inactive;

    this.currentItem = index;
  }

  cardClick(item: any, index: number) {
    if (item.state === VideoState.active) return;

    if (!this.isClicked) this.isClicked = true;

    this.toggleVideoState(item, index);
  }

  dropdownClick(item: any, index: number) {
    if (item.state === VideoState.active) return;

    if (!this.isClicked) this.isClicked = true;

    if (this.dropdownOpened = DropdownState.opened) {
      this.toggleVideoState(item, index);
    }
  }

  nextItem() {
    if (this.isClicked === true) return;

    if (this.currentItem === this.arrayLength() - 1) {
      this.items[0].state = VideoState.active;
      this.items[this.currentItem].state = VideoState.inactive;

      this.items[0].dropdown = DropdownState.opened;
      this.items[this.currentItem].dropdown = DropdownState.closed;

      this.currentItem = 0;
    } else {
      this.items[this.currentItem + 1].state = VideoState.active;
      this.items[this.currentItem].state = VideoState.inactive;

      this.items[this.currentItem + 1].dropdown = DropdownState.opened;
      this.items[this.currentItem].dropdown = DropdownState.closed;

      this.currentItem = this.currentItem + 1;
    }
  }

  arrayLength(): number {
    return this.items.length;
  }

  toggleDropdownState() {
    if (this.dropdownOpened === DropdownState.closed) {
      this.items.forEach(item => {
        item.dropdown = DropdownState.opened;
      });
      this.dropdownOpened = DropdownState.opened;
    } else {
      this.items.forEach(item => {
        item.dropdown = DropdownState.closed;
      });
      this.dropdownOpened = DropdownState.closed;

      this.items[this.currentItem].dropdown = DropdownState.opened;
    }
  }

  assembleHTMLItem(item: any) {
    return this._sanitizer.bypassSecurityTrustHtml(item);
  }
}
